import itemsplanesData from '../data/itemsplanes';
import ObtenerServiciosPlanes from '../functions/ObtenerServiciosPlanes';

export const CargarItemsPlan = () => {
    //const itemsDelPlan = itemsplanesData.filter(item => item.idplanes.includes(idPlan));
    return itemsplanesData;
};

export const CargarItemsPlanesDB = async () => {
    const itemsplanesData = await ObtenerServiciosPlanes("activos", 0);
    //console.log(itemsplanesData.servicios_planes);
    //transformar los resultados al formato de itemsplanesData
    const itemsplanesDataTransformado = itemsplanesData.servicios_planes.map((item: any) => {
        return {
            id: item.id,
            title: item.nombre,
            idplan: item.idplan
        };
    });
    //console.log(itemsplanesDataTransformado);
    return itemsplanesDataTransformado;
};
